import { Box, Typography } from "@mui/material";
import Header from "../../components/Header";

const Terms = () => {
  return (
    <Box maxWidth={1000} m="auto" width={"90%"} pt={16}>
      <Header label="Protein Box" title="Terms of Service" />
      <Box mt={4}>
        <Typography variant="body1" color="text.secondary">
          These Terms and Conditions (“Terms”) govern the use of our website
          https://protein-box.com (“Website” or “Site”) by Purchaser(s) (“you”
          or “your”) and your relationship with STRENGTH & CONDITIONING
          NUTRITION, hereinafter referred to as (“SCN” or “We”). Please read the
          Terms carefully, as they affect your legal rights and obligations. If
          you do not agree to these Terms, please do not access or use the
          Website and the e-Shop. Using the services and purchasing products
          offered on this Website means that you have read and understood these
          Terms and agree to comply with the provisions contained herein.
          <br />
          <br />
          <Box component="span" color="text.primary">
            I. DEFINITIONS
          </Box>
          <br />
          In the interpretation and application of these Terms, the following
          terms and expressions have the following meanings: “Purchaser” means a
          Consumer or an Entity who has accepted these Terms. “e-Shop” means an
          online shopping website owned and operated by the SCN in which a User
          or Purchaser may acquire Goods from the Company via the internet.
          “Consumer” means a natural person who by concluding and fulfilling a
          consumer contract does not act within the interest of a business or
          any other entrepreneurship activity. “Entity” means a legal entity
          duly incorporated and registered with the relevant business register.
          “Privacy Policy” means the privacy policy of SCN, which can be read on
          the Website. “Registration” means creating a profile on the Website.
          “Third country” means a country that is not a member of the European
          Union as well as a country or territory whose citizens do not enjoy
          the European Union’s right to free movement. “User(s)” means an
          individual who interacts with the Website, in any way.
          <br />
          <br />
          <Box component="span" color="text.primary">
            II. GENERAL CONDITIONS
          </Box>
          <br />
          1. To shop and use all services of the SCN e-shop, it is necessary for
          a Purchaser to be a natural person (aged or over 18 or an Entity, and
          to have registered voluntarily by completing the registration form on
          the Website which includes a valid e-mail address and password. Once
          the registration is completed, the Purchaser also needs to provide
          additional information, such as: full name, telephone number, delivery
          address, or if applicable, name of Entity and VAT number.
          <br /> 2. In case of incorrect and/or inaccurate data, the SCN
          reserves the right to terminate any profile and cancel pending orders.{" "}
          <br /> 3. SCN shall indicate on the e-Shop the name, main
          characteristics, final price, description, and currency for each
          product. <br /> 4. SCN may provide, at its own discretion, additional
          information for each product. <br /> 5. SCN reserves the right to
          change prices without prior notice to Purchasers. The Purchaser shall
          pay the price that is displayed on the Website for the relevant item
          at the time of the order. <br /> 6. SCN may organize special offers,
          whereas it reserves the right to terminate, change the terms, extend,
          or permanently suspend such special offers, at any time, by way of
          uploading a public announcement on the Website.
          <br />
          <br />
          <Box component="span" color="text.primary">
            III. ORDER OF GOODS AND SERVICES. CONCLUDING OF CONTRACT 7
          </Box>
          <br />
          The Purchaser can purchase goods and services online from the Website,
          after logging into their account through the button “Login” using
          their email address and password or as a guest by filling-in the
          relevant information for the purchase, such as name, company name (if
          applicable), delivery address, telephone number, email address and
          payment details. 8. The Purchaser selects a specific product by
          clicking on the button “Add to basket” button available when viewing
          the products. Pressing this button saves the selected product in a
          virtual user basket. 9. The Purchaser can view the contents of the
          basket, add new products or remove already added products. 10. The
          Purchaser confirms his order by pressing the button “Place order”. 11.
          The Purchaser must confirm that he has familiarized himself with the
          Terms and that accepts them, otherwise, the order shall not be
          completed and/or processed. 12. When an order is placed and it is
          registered by SCN, Purchaser shall receive an email with a summary of
          his order (i.e. order number, a list with selected products, units,
          the total value of the order, delivery price, and delivery address)
          Such communication does not represent a confirmation of its execution
          by SCN. Until confirmation of the order, which is done by sending a
          separate e-mail confirmation for dispatching the order, accompanied by
          an invoice, SCN has the right not to fulfil the order in whole or in
          part due to reasons beyond its control. In case such an event arises,
          SCN must notify the Purchaser by a separate email and return the
          payment without delay. 13. If the Purchaser’s data is filled in
          incorrectly and/or inaccurately, SCN shall cancel the order, which
          automatically shall terminate the distance contract. 14. A distance
          sales contract between SCN and the Purchaser is considered to have
          been concluded from the moment the specific order is confirmed by the
          SCN with an e-mail confirmation for dispatching the order, accompanied
          by an invoice. 15. A registered User can store and monitor in his
          profile chronological information about purchases made by him in the
          past as well as on current orders. 16. All goods, including those in
          stock, promotion/discount, are sold and delivered until supplies last,
          even if not expressly stated on the site. 17. If the ordered products
          are out of stock, SCN must notify the Purchaser, specifying additional
          options for ordering and an approximate delivery time. 18. SCN
          reserves the right to cancel an order in case of violation of any of
          these Terms, notifying the Purchaser accordingly. 19. Upon written
          inquiries and opinions received through the SCN contact form, an
          opinion or response shall be issued to the User within 14 business
          days. 20. SCN reserves the ownership over the item until the Purchaser
          transfers the full price and receives each order. 21. SCN shall
          dispatch the order to the Purchaser together with the relevant
          documentation. 22. SCN is considered to have delivered the order to
          the Purchaser once the item has been handed over personally to the
          Purchaser by SCN or by the relevant carrier. 23. SCN delivers the
          order to the Purchaser in the agreed-upon quantity, quality, and
          specifications. 24. Unless a specific agreement has been made about
          the manner of packaging, the items will be packaged according to
          regular custom, or, in absence of such custom, packaged so as to
          protect the items from any reasonable damage. The item will be
          arranged in such a manner by SCN for the purposes of shipping as well.
          25. In order to minimize the risk of possible damages and to avoid any
          supply issues, SCN reserves the right to deliver the goods to the
          Purchaser only after receiving the full price of the purchase.
          <br />
          <br />
          <Box component="span" color="text.primary">
            IV. WARRANTIES AND SPECIFICATIONS 26.
          </Box>
          <br /> SCN undertakes to provide technical specifications for the
          products that are part of the distance sales contract, ensuring that
          the described data is based on the technical specification of the
          manufacturing facility. 27. SCN does not guarantee a quality other
          than that described quality in the technical specification. The
          Purchaser assumes all risk and responsibility for the use of the
          goods, whether used separately or in combination with other
          substances, and for any loss or damage and/or injury to persons
          arising from the use or possession of the goods subject to the
          contract for sale. 
          <br />
        <br />
        <Box component="span" color="text.primary">
   V. COMPLAINTS AND WITHDRAWAL FROM THE CONTRACT ON
          THE TERRITORY OF THE EUROPEAN UNION BY CONSUMERS 28
        </Box>
        <br />
       . Upon receipt of
          the goods, the Purchaser is obliged to immediately perform an
          inspection, and in the event that he finds visible defects such as
          broken integrity of the packaging, transport defects, or lack of
          accompanying documents, the Purchaser must immediately inform the
          carrier that is making the delivery. 29. In the event that there are
          defects or identified deficiencies in the package, in the presence of
          the courier or the person carrying out the delivery, the Purchaser
          must sign a protocol with the responsible person carrying out the
          delivery (e.g. delivery company) evidencing his denial to receive the
          shipment and to send this protocol to SCN at the following email
          address: info@s-c-nutrition.com 30. In the event that the Purchaser
          fails to inspect the goods upon delivery and, therefore, fails to make
          immediate claims to the person carrying out the delivery, the goods
          shall be considered approved and accepted, and the Purchaser shall
          lose the right to claim at a later stage. 31. In the event that a
          Consumer has voluntarily chosen a courier company with which SCN does
          not have a contractual relationship for the delivery of his order or
          has assigned such a courier company to return the goods back to SCN,
          the risk of loss or damage to the goods is entirely at the Purchaser’s
          expense according to Art. 103B paragraph 2 of the Consumer Protection
          Act and the Purchaser shall be entitled to submit his claims directly
          to the carrier, 32. A Consumer in the sense of the applicable EU
          legislation has the right to withdraw from an already concluded
          distance Contract without providing a reason within up to 14 days from
          the day of delivery of goods or the service, while it is necessary
          that within this time limit a record has to be made and sent (via a
          letter or an e-mail), informing SCN about the withdrawal from the
          Contract. 33. A Consumer who has exercised the right of withdrawal
          pursuant to the applicable legislation must return the goods to SCN
          within 7 calendar days of making the withdrawal and pay any transport
          costs for returning the goods according to Article 55 paragraph 2 of
          the Consumer Protection Act. 34. SCN shall refund the amount paid by
          the Consumer for the purchased product, including within 14 days from
          the date of notification of the Consumer‘s decision to withdraw from
          the contract. At its own discretion, SCN may cover the delivery costs
          for returning the products. SCN may withhold any repayment of sums to
          the Consumer under the previous sentence until it receives the goods
          or until the Consumer provides proof that it has sent the goods back
          that are sufficient for SCN, whichever occurs first. 35. The
          provisions of Art. 50 – 56 of the Consumer Protection Act, concerning
          the right of withdrawal by the Consumer shall not apply to contracts
          for the supply of sealed goods that are unsealed after their delivery
          and not may be returned for hygiene or health protection reasons, as
          well as for the delivery of goods which, after being delivered and due
          to their nature, have become mixed with other goods from which they
          cannot be separated. 36. SCN is not obliged to cover the additional
          costs of the Consumer if the Consumer explicitly chooses to use any
          other means of delivery for returning the goods other than the most
          economical, regular manner of delivery offered by SCN. The additional
          cost is calculated as a difference between the manner of delivery
          chosen by the Consumer and the most economical, regular manner of
          delivery offered by SCN. 37. The Purchaser takes note that if the
          purchased goods come with gifts, the deed of donation between the
          Purchaser and SCN is only valid for as long as the Purchaser does not
          withdraw from the purchase contract, in which case the deed of
          donation becomes void and the Purchaser is obliged to return the gifts
          that came with the purchased goods intended for return. In case the
          gifts are not returned together with the returned purchased goods, the
          value of these gifts will be considered as unjust enrichment of the
          Purchaser. 38. After fulfilling all the aforementioned conditions for
          returning the purchased goods, the Consumer becomes entitled to a
          refund of the amount paid for the returned goods, which will be
          refunded to the Consumer at the latest within 14 business days from
          the withdrawal from the contract. SCN is however not obliged to refund
          this payment until the returned goods are delivered by the Consumer,
          or until when the Consumer provides a proof of having sent the goods
          intended for return back to SCN. SCN is obliged to refund the amount
          equivalent to the price of the purchase in the same manner that was
          used by the Consumer upon the initial payment, unless the Consumer and
          SCN agree on a different manner of refunding, in which no additional
          fees are to be paid by SCN in order to complete this refund. 39. SCN
          warns that in case the goods returned upon the Consumer’s withdrawal
          from the Contract are damaged, worn, incomplete, without accompanying
          documentation (the original proof of purchase, warranty card,
          instructions for use, etc.), or returned without gifts provided with
          the purchase, SCN will claim the damage against the Consumer, possibly
          through the courts and a legal representative. SCN also warns that
          before each shipment of goods, they document the completeness and
          integrity of the shipped goods. 40. In case of the circumstances
          specified in Art. 28, Art. 29, and Art. 30 above, or loss of the
          goods, SCN shall not refund the amount paid for the goods and any, and
          all related costs. VI. PRICES 41. All the prices are contractual. The
          e-Shop will always display only the current and up-to-date prices.
          Prices are final, including VAT and any other taxes or fees that the
          Purchaser is obliged to pay. This does not include additional fees for
          shipping and delivery. 42. Sale prices apply either during a
          predetermined amount of time or until the stock of a specified
          quantity runs out. 43. The original base price is the price of the
          product/service/license that the product or service was offered for by
          SCN before applying any particular sale bonuses and discounts related
          to marketing campaigns and other discounts in the operating e-shop, or
          the price of the product or service suggested by the manufacturer or
          the distributor, while the displayed price is always the price that
          better reflects the price level of the specific item on the market.
          VII. PAYMENT CONDITIONS 44. Payment can be made by any major credit or
          debit card. Payment will be debited and cleared from your account
          before the dispatch of your goods or the provision of the service to
          you. 45. SCN accepts the following payment methods and conditions: a)
          Payment in advance via a bank account transfer, b) Payment via an
          online bank interface (payment via a card online), c) Payment on
          invoice due date (only for Entities if the conditions are met). 46.
          The goods remain the property of SCN until they are fully paid for and
          delivered to the Purchaser. The risk of damage to the goods passes to
          the Buyer once the goods have been delivered to them. 47. The
          purchaser’s billing information cannot be changed retroactively after
          placing the order. 48. In the unlikely event that the price shown on
          the checkout page is wrong, and SCN discovers this before accepting
          your order, we shall not be required to sell the goods to you at the
          price shown. We always try and ensure that the prices of goods shown
          on our Website are accurate, but occasionally genuine errors may
          occur. If we discover an error in the price of the goods that you have
          ordered, we will let you know as soon as possible and give you the
          option of reconfirming your order at the correct price or cancelling
          it. If you cancel your order and you have already paid for the goods
          (but they have not yet been dispatched), then you will receive a full
          refund. 49. You must use a credit or debit card registered under your
          name. If your credit or debit card payment is not processed
          successfully for any reason, we reserve the right to reattempt to
          process payment. We will give you at least 48 hours’ notice in advance
          of any reattempt to process payment by sending an email to the email
          address you have provided to us. If you do not want us to reattempt to
          process payment, you must cancel your order within 48 hours of us
          sending you this email. VIII. TERMS OF DELIVERY 50. All orders are
          dispatched between 1-3 business days from the order date from within
          the European Union and must reach any of the member states in several
          days. 51. If your delivery address is within the European Union, no
          additional taxes will be charged to you. 52. If your delivery address
          is outside of the European Union you should allow DPD or UPS 10-15
          days to deliver your order. Please note that you are responsible for
          any import formalities as well as any import duties and taxes
          (including VAT), which are levied once a delivery reaches your
          destination country and might be due. Any such additional charges must
          be borne by you. You should note that customs policies and practices
          vary widely from country to country. We recommend that you contact the
          local customs office for more information before making any orders.
          53. Every Purchaser from a Third country must be aware of the
          applicable charges of their country when they make imports from the
          European Union. 54. SCN shall not be held liable if any or the total
          part of your order is seized by the customs authorities in your
          country. 55. SCN shall not accept any returns of seized orders, nor
          will make any refunds for orders made from Third countries. In case
          you are not certain whether your order will be able to enter your
          state, please contact a designated customs agent and ask for support.
          56. For the avoidance of any doubt, a parcel shall not be considered
          lost if it is seized by the customs authorities of a Third country
          and/or the Purchaser refuses to proceed with the respective clearance
          formalities, and SCN shall not refund or resend any products. IX.
          AMENDMENTS 57. We reserve the right to a) update these Terms from time
          to time and any changes will be notified to you via a suitable
          announcement on the Website. It is your responsibility to check for
          such changes. The changes will apply to the use of the Website after
          we have given such an announcement. If you do not wish to accept the
          new Terms you should not continue to use the Website. If you continue
          to use the Website after the date on which the change comes into
          effect, your use of the Website indicates your agreement to be bound
          by the new Terms; b) modify or withdraw, temporarily or permanently,
          this Website and the material contained within (or any part) without
          notice to you and you confirm that we shall not be liable to you for
          any modification to or withdrawal of the Website or its contents; c)
          and disable any User profile, any time, if in our opinion you have
          failed to comply with any of the provisions of these Terms. X.
          INTELLECTUAL PROPERTY 58. The content of the Website is protected by
          copyright, trade marks, database and other intellectual property
          rights and you acknowledge that the material and content supplied as
          part of the Website shall remain with us or our licensors. You may
          retrieve and display the content of the Website on a computer screen,
          store such content in electronic form on disk (but not any server or
          other storage device connected to a network) or print one copy of such
          content for your own personal, non-commercial use, provided you keep
          intact all and any copyright and proprietary notices. You may not
          otherwise reproduce, modify, copy or distribute or use for commercial
          purposes any of the materials or content on the Website without the
          prior written consent of SCN. XI. REVIEWS 59. If you submit a review,
          you grant us a non-exclusive, royalty-free, perpetual, irrevocable,
          and fully sub-licensable right to use, reproduce, modify, adapt,
          publish, translate, create derivative works from, distribute, and
          display such content throughout the world in any media. 60. You grant
          SCN and its sub-licensees the right to use the name that you submit in
          connection with such content if we choose to do so. 61. You agree to
          waive your right to be identified as the author of such content and
          your right to object to derogatory treatment of such content. 62. You
          agree to perform all further acts necessary to perfect any of the
          above rights granted by you to SCN, including the execution of deeds
          and documents, at the request of SCN. 63. You represent and warrant
          that you own or otherwise control all of the rights to the content
          that you post; that, as at the date that the content or material is
          submitted to SCN: a) The content and material are accurate; b) Use of
          the content and material you supply does not breach any applicable SCN
          guidelines and will not cause injury to any person or entity
          (including that the content or material is not defamatory). c) You
          agree to indemnify SCN for all claims brought by a third party against
          SCN arising out of or in connection with a breach of any of these
          warranties. XII. LIMITATION OF LIABILITY 64. You agree to defend,
          indemnify and hold harmless SCN, its affiliated companies, officers,
          directors, employees and agents, from and against any and all claims,
          damages, obligations, losses, liabilities, costs or debts, and
          expenses (including but not limited to attorney’s fees) arising from:
          (i) your violation of any term of these Terms; (ii) your violation of
          any third party right, including without limitation any trade mark,
          copyright, property, or privacy right; or (iii) your activities in
          connection with SCN’s website. 65. Supply of Goods: (a) if we fail to
          comply with these Terms, we shall only be liable to you for losses
          that you suffer as a result of our failure to comply (whether arising
          in contract, tort (including negligence), breach of statutory duty or
          otherwise) which are a foreseeable consequence of such failure. (b)
          Nothing in these Terms excludes or limits our liability for: (i) death
          or personal injury caused by our negligence; (ii) fraud or fraudulent
          misrepresentation; (iii) defective products; or (v) any deliberate
          breaches of these Terms that would entitle you to terminate the
          Contract; or (vi) any other matter for which it would be illegal for
          us to exclude or attempt to exclude our liability. The use of the
          Website any provided on an “as is” and “as available” basis without
          any representation or endorsement made and we make no warranties,
          whether express or implied, in relation to it and its use. You
          acknowledge that we cannot guarantee and cannot be responsible for the
          security or privacy of the Website and any information provided by
          you. You must bear the risk associated with the use of the Internet.
          Whilst we will try to ensure that the material included on the Website
          is correct, reputable and of high quality, we cannot accept
          responsibility if this is not the case. We will not be responsible for
          any errors or omissions, the results obtained from using such
          information, or any technical problems you may experience with the
          Website. If we are informed of any inaccuracies in the material on the
          Website we will attempt to correct this as soon as we reasonably can.
          We disclaim all liabilities in connection with the following:
          incompatibility of the Website with any of your equipment, software or
          telecommunications links; technical problems including errors or
          interruptions of the Website; unsuitability, unreliability or
          inaccuracy of the Website; and failure of the Website to meet your
          requirements. To the full extent allowed by applicable law, you agree
          that we will not be liable to you or any third party for any
          consequential or incidental damages (both of which terms include,
          without limitation, pure economic loss, loss of profits, loss of
          business, loss of anticipated savings, wasted expenditure, loss of
          privacy and loss of data) or any other indirect, special or punitive
          damages whatsoever that arise out of or are related to your use of the
          Website. XIII. SEVERANCE 66. If any part of the Terms shall be deemed
          unlawful, void or for any reason unenforceable, then that provision
          shall be deemed severable from these Terms and shall not affect the
          validity and enforceability of any remaining provisions of the Terms.
          XIV. WAIVER 67. No waiver by us shall be construed as a waiver of any
          proceeding or succeeding breach of any provision. XV. ENTIRE AGREEMENT
          68. These Terms form the entire basis of any agreement reached between
          you and SCN.
        </Typography>
      </Box>
    </Box>
  );
};

export default Terms;
